const hostname = window.location.hostname;

let reactApi_baseUrl = "";

if (hostname === "localhost" || hostname === "127.0.0.1") {
  // Local development
  reactApi_baseUrl = "http://localhost/Projects/thepixelbakery.nl";
} else {
  // Live domain
  reactApi_baseUrl = "https://thepixelbakery.nl/app";
}

let googleAddressApiKey = "AIzaSyAwlOlLs8PybiBMBAB6_d73bUsxU2ZI06E";

const config = {
  reactApi_baseUrl,
  googleAddressApiKey
};

export default config;